// Bulk permanent-delete failures table — the Song Library's failures dialog
// (src/pages/songs.tsx ~1586-1637) generalised over the entity noun.

import React from 'react';
import { Modal, Table, Button as AntdButton } from 'antd';
import { EntityRefBadge } from '@/components/EntityRef/EntityRefBadge';
import type {
  CatalogEntityKind,
  CatalogPurgeFailure,
} from './catalogLifecycleTypes';
import { catalogCopy } from './catalogEntityCopy';

interface CatalogPurgeFailuresModalProps {
  kind: CatalogEntityKind;
  open: boolean;
  failures: CatalogPurgeFailure[];
  onClose: () => void;
}

export function CatalogPurgeFailuresModal({
  kind,
  open,
  failures,
  onClose,
}: CatalogPurgeFailuresModalProps) {
  const { Noun, nounPlural, refKind } = catalogCopy(kind);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={720}
      destroyOnClose
      title="Permanent delete failures"
    >
      <div style={{ padding: '8px 0 16px' }}>
        <p style={{ color: '#555', marginBottom: 16 }}>
          These {nounPlural} did not reach a verified deleted end-state.
          Retryable failures can be run again — deletion resumes where it left
          off.
        </p>
        <Table
          size="small"
          pagination={false}
          rowKey="id"
          dataSource={failures}
          columns={[
            {
              title: `${Noun} Name`,
              dataIndex: 'name',
              key: 'name',
              render: (value: string | null) => value || '—',
            },
            {
              title: `${Noun} ID`,
              dataIndex: 'id',
              key: 'id',
              render: (value: string) => (
                <EntityRefBadge kind={refKind} id={value} />
              ),
            },
            {
              title: 'Failure reason',
              dataIndex: 'message',
              key: 'message',
            },
            {
              title: 'Retryable?',
              dataIndex: 'retryable',
              key: 'retryable',
              width: 100,
              render: (value: boolean) => (value ? 'Yes' : 'No'),
            },
          ]}
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
          <AntdButton type="primary" onClick={onClose}>
            Close
          </AntdButton>
        </div>
      </div>
    </Modal>
  );
}
